import { UntypedFormControl } from '@angular/forms';
import { StringUtils } from '../utils/string.utils';

export function validateIssnFormat(control: UntypedFormControl) {
    const issnFormat = control.value as string;
    if (issnFormat && !issnFormat.match(StringUtils.regexIssn)) {
        return {
            validateIssnFormat: 'research.status.issn.error.default.default',
        };
    }
    return null;
}
